import { Middleware, AnyAction } from 'redux'
import { RootState } from '../reducers'

type ActionObserver = (action: AnyAction) => void

class ActionObserverRegistry {
  private observers = new Set<ActionObserver>()

  subscribe(observer: ActionObserver): () => void {
    this.observers.add(observer)
    return () => {
      this.observers.delete(observer)
    }
  }

  notify(action: AnyAction): void {
    this.observers.forEach(observer => {
      try {
        observer(action)
      } catch (error) {
        console.error('Error in action observer:', error)
      }
    })
  }

  getObserverCount(): number {
    return this.observers.size
  }
}

// Global registry instance
export const actionObserverRegistry = new ActionObserverRegistry()

// Middleware that notifies all registered observers
export const observerMiddleware: Middleware<unknown, RootState> = () => next => action => {
  const result = next(action)

  // Notify observers after the action has been processed
  if (action && typeof action === 'object' && 'type' in action) {
    actionObserverRegistry.notify(action)
  }

  return result
}
